import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { decisioningFactorsQueryKey } from "../decisioning.keys";
import { CATALOG_STALE_TIME_MS } from "./catalog";

const parseFactors = (data: unknown) =>
	Dtos.Decisioning.Factor.Get.Response.schema.array().parse(data);

export const useFetchDecisioningFactors = () => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: decisioningFactorsQueryKey(),
		queryFn: async () => parseFactors(await get<unknown>("/v2/admin/decisioning/factors")),
		staleTime: CATALOG_STALE_TIME_MS,
	});

	return {
		factors: query.data,
		factorsIsLoading: query.isLoading,
		factorsError: query.error,
	};
};
